export default __webpack_public_path__ + "static/media/Neddie-Screen-1.9dc3b50a.png";